export default __webpack_public_path__ + "static/media/clouds-right-tablet.bba194bc.png";